export default __webpack_public_path__ + "static/media/pig game.9f86eb22.png";